'use client';
import { lazy, type ComponentProps } from 'react';
export type * from "/tmp/build-510/overrides/components/advisory/advisory-header.tsx";
const Deferred0 = lazy(() => import("@eliadmin/page-island-original/d3b7d767c1fc").then(m => ({ default: m.AdvisoryHeader })));
const Island0 = ((props: NonNullable<ComponentProps<typeof import("/tmp/build-510/overrides/components/advisory/advisory-header.tsx").AdvisoryHeader>>) => <Deferred0 {...props} />) as typeof import("/tmp/build-510/overrides/components/advisory/advisory-header.tsx").AdvisoryHeader;
export { Island0 as AdvisoryHeader };
